import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateBidAnswerByIdMutation,
  UpdateBidAnswerByIdMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "lib/hooks/api/useGraphQlClient";

export const updateBidAnswerById = graphql(`
  mutation UpdateBidAnswerById($input: UpdateBidAnswerRequest!) {
    updateBidAnswerById(UpdateBidAnswerRequest: $input) {
      bidId
      answer {
        answer
      }
    }
  }
`);

export function useUpdateBidAnswerById(
  options?: UseMutationOptions<
    UpdateBidAnswerByIdMutation,
    unknown,
    UpdateBidAnswerByIdMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(updateBidAnswerById, {
    ...options,
    onSuccess: async (data, vars, ctx) => {
      options?.onSuccess?.(data, vars, ctx);

      // TODO: Could make this more efficient by finding the bid answer in the
      // cache and updating it directly
      //  Update the cache so the getBidReport query fetch uses it
      await queryClient.invalidateQueries(["get_bid_report", data.updateBidAnswerById.bidId]);
    },
  });

  return { data: data?.updateBidAnswerById, ...rest };
}
